// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"ff2dc801","821":"14e950cd"}[chunkId] + ".chunk.js";
};